import React, { useContext, useEffect, useState } from 'react';
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework';
import UserContext from './UserContext';
import { UserInfo } from '../interfaces/IUserInfo';

interface Props {
  children: React.ReactNode;
}

const UserContextProvider = ({ children }: Props) => {
  const [userInfo, setUserInfo] = useState<UserInfo>(
    () => JSON.parse(localStorage.getItem('userInfo') || '{}')
  );
  const {context} = useContext(EbAuthenticatedAppContext);

  const handleGetUserinfo = async () => {
    const userInfo = await context.restApiClient
      .buildRequest('/api/userinfo')
      .deserializeResponseToJson<UserInfo>()
      .getAsync();

    if(userInfo.json){
      setUserInfo(userInfo.json);
    }
  };

  useEffect(() => {
    handleGetUserinfo();
  }, [context.restApiClient]);

  const contextValue = {
    userInfo,
    setUserInfo
  };

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
